export default __webpack_public_path__ + "locales/es/SingleSignOn.json?hash=504446f1b1e1bf2c15667bb0127888d3";